var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaceleonnegative({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 412,
    height: 600,
    viewBox: "0 0 412 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "face_leon_negative_svg__d",
    d: "M16.605 125.578C14.064 63.68 62.059 9.373 123.805 4.493c0 0 45.744-4.25 59.118-3.764l15.78 1.582C260.342 8.491 303.84 63.3 295.857 124.74l-12.178 93.73-262.991 6.565-4.083-99.456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_leon_negative_svg__e",
    d: "M.47 25.54C.47 11.686 11.695.455 25.552.455c13.852 0 25.083 11.235 25.083 25.085v17.068c0 13.854-9.127 31.636-20.38 39.712l-4.703 3.376-4.704-3.376C9.594 74.242.47 56.458.47 42.608V25.54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "face_leon_negative_svg__g",
    d: "M.527 122.515C-.316 54.852 53.854 0 121.528 0h8.016c67.67 0 119.53 54.78 115.834 122.342l-3.197 58.42c-3.697 67.568-61.414 118.356-128.89 113.44l11.47.836C57.273 290.122 1.881 231.284 1.038 163.622l-.512-41.107z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "face_leon_negative_svg__c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#12B2B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#235A70"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "face_leon_negative_svg__a",
    width: 412,
    height: 600,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_leon_negative_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_leon_negative_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_leon_negative_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46 70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 313.31 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#face_leon_negative_svg__c)",
    xlinkHref: "#face_leon_negative_svg__d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D4B680",
    stroke: "#363A4F",
    strokeWidth: 12.6,
    d: "M157.513-4.552c10.55-.718 20.693-1.218 25.847-1.007h0l15.972 1.602c32.602 3.269 60.397 19.412 78.992 42.845 18.595 23.432 28.003 54.167 23.78 86.663h0l-12.873 99.081-274.584 6.854-4.337-105.65C8.97 93.206 20.94 62.567 41.402 39.453 61.852 16.354 90.773.786 123.297-1.787c1.22-.113 17.099-1.574 32.606-2.654h0z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.512,
    cy: 212.145,
    fill: "#FCD9C8",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.481,
    cy: 217.067,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.031,
    cy: 212.145,
    fill: "#FCD9C8",
    stroke: "#363A50",
    strokeWidth: 12.6,
    rx: 32.731,
    ry: 32.778
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 215.067,
    r: 14,
    fill: "#000",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(138.575 300.547)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_leon_negative_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_leon_negative_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M25.036-5.84c8.956-.004 16.862 3.49 22.572 9.107 5.786 5.69 9.328 13.57 9.328 22.273h0v17.068c0 15.64-10.303 35.713-23.007 44.83h0l-8.376 6.013-8.377-6.012C4.47 78.319-5.831 58.243-5.831 42.609h0v-17.07c0-8.573 3.437-16.343 9.008-22.007 5.58-5.674 13.303-9.234 21.859-9.373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M25.036-5.84c8.956-.004 16.862 3.49 22.572 9.107 5.786 5.69 9.328 13.57 9.328 22.273h0v17.068c0 15.64-10.303 35.713-23.007 44.83h0l-8.376 6.013-8.377-6.012C4.47 78.319-5.831 58.243-5.831 42.609h0v-17.07c0-8.573 3.437-16.343 9.008-22.007 5.58-5.674 13.303-9.234 21.859-9.373z",
    mask: "url(#face_leon_negative_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M34.763 16.775s-52 11-8 73l-27-13-11-57 1-6 45 3z",
    mask: "url(#face_leon_negative_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.995 38.185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "face_leon_negative_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#face_leon_negative_svg__g"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M129.544 6.3c31.997 0 60.274 12.922 80.103 33.865 19.83 20.945 31.188 49.886 29.44 81.833h0l-3.197 58.42c-1.695 30.976-15.362 58.237-36.272 77.596-20.944 19.39-49.147 30.85-79.832 30.19-31.063-3.842-58.962-19.424-79.207-41.822-20.24-22.392-32.851-51.62-33.24-82.839h0l-.513-41.106c-.4-32.071 12.233-61.11 32.99-82.127C60.576 19.293 89.454 6.3 121.529 6.3h8.016z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCD9C8",
    stroke: "#363A50",
    strokeWidth: 12.6,
    d: "M129.544 6.3c31.997 0 60.274 12.922 80.103 33.865 19.83 20.945 31.188 49.886 29.44 81.833h0l-3.197 58.42c-1.695 30.976-15.362 58.237-36.272 77.596-20.944 19.39-49.147 30.85-79.832 30.19-31.063-3.842-58.962-19.424-79.207-41.822-20.24-22.392-32.851-51.62-33.24-82.839h0l-.513-41.106c-.4-32.071 12.233-61.11 32.99-82.127C60.576 19.293 89.454 6.3 121.529 6.3h0z",
    mask: "url(#face_leon_negative_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M8.578 125.172s50-99 70-89 98.852 63.926 167.926 63.926c69.074 0 10.074-25 10.074-25l-98-54-93-19-46 19-31 97 20 7.074zM246.621 163.98s-24 116.172-130 122l50.926 4 88-58-8.926-68z",
    mask: "url(#face_leon_negative_svg__h)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 9,
    d: "M242.57 140.083c-6.265-10.852-23.549-12.604-38.604-3.912M78.06 140.083c6.265-10.852 23.55-12.604 38.604-3.912"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 224.394,
    cy: 194.421,
    fill: "#FFF",
    rx: 19.23,
    ry: 14.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.617,
    cy: 194.421,
    fill: "#FFF",
    rx: 19.23,
    ry: 14.546
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.409,
    cy: 195.135,
    fill: "#363A50",
    rx: 7.554,
    ry: 9.366
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8.82,
    d: "M144.437 239.02s7.148 11.484 15.966 11.484c8.817 0 15.966-11.485 15.966-11.485"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.41,
    d: "M25.814 204.723c5.371-3.227 12.338-1.495 15.561 3.87h0c3.223 5.364 1.483 12.329-3.888 15.556M279.129 206.684c4.728-4.11 11.89-3.614 15.996 1.109h0c4.106 4.723 3.6 11.884-1.128 15.995"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.171,
    cy: 195.135,
    fill: "#363A50",
    rx: 7.554,
    ry: 9.366
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "94.542 44.135 83.542 66.135 107.542 50.135"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M114.542 27.135s135-43 172 95c-23.926-157.739-172-95-172-95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M161.573 203.322s-18.074 35 9 43h-17.926l-9-9 17.926-34z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_leon_negative_svg__b)",
    opacity: 0.154
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#747171",
    transform: "rotate(-2 6307.38 -2864.969)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.726,
    cy: 75.507,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.894,
    cy: 70.841,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.03,
    cy: 67.088,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.198,
    cy: 76.6,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.41,
    cy: 84.623,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.545,
    cy: 80.87,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.608,
    cy: 122.212,
    rx: 2.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.366,
    cy: 86.111,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.521,
    cy: 81.241,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.17,
    cy: 91.852,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.886,
    cy: 71.33,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.056,
    cy: 66.577,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.707,
    cy: 76.571,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.842,
    cy: 72.818,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.013,
    cy: 68.065,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.664,
    cy: 78.059,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.358,
    cy: 86.6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.528,
    cy: 81.813,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.179,
    cy: 91.841,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.315,
    cy: 88.053,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.485,
    cy: 83.3,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.636,
    cy: 93.312,
    rx: 2.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.869,
    cy: 72.307,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.144,
    cy: 64.539,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.826,
    cy: 73.778,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.961,
    cy: 70.007,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.647,
    cy: 79.036,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.341,
    cy: 87.542,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.476,
    cy: 83.789,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.162,
    cy: 92.784,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.298,
    cy: 89.03,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.433,
    cy: 85.277,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.119,
    cy: 94.272,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.818,
    cy: 74.249,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.988,
    cy: 69.496,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.639,
    cy: 79.49,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.792,
    cy: 75.237,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.944,
    cy: 70.984,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.595,
    cy: 80.978,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.254,
    cy: 90.518,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.907,
    cy: 86.248,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.075,
    cy: 95.76,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.711,
    cy: 91.989,
    rx: 2.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.364,
    cy: 87.718,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.823,
    cy: 103.244,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.8,
    cy: 75.261,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 129.214,
    cy: 63.513,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.621,
    cy: 80.502,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.756,
    cy: 76.749,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.909,
    cy: 72.496,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.578,
    cy: 81.99,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.168,
    cy: 93.459,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.338,
    cy: 88.707,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.989,
    cy: 98.701,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.125,
    cy: 94.947,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.295,
    cy: 90.195,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.946,
    cy: 100.189,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150.782,
    cy: 76.273,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.918,
    cy: 72.52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 157.569,
    cy: 82.514,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.739,
    cy: 77.761,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.538,
    cy: 83.246,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.979,
    cy: 70.975,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.108,
    cy: 64.636,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.22,
    cy: 92.473,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.355,
    cy: 88.719,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.524,
    cy: 98.231,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.177,
    cy: 93.961,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.136,
    cy: 95.274,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.316,
    cy: 118.247,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.487,
    cy: 113.495,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.138,
    cy: 123.489,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.273,
    cy: 119.735,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.096,
    cy: 93.583,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.781,
    cy: 102.613,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.917,
    cy: 98.824,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.07,
    cy: 94.571,
    rx: 2,
    ry: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.238,
    cy: 104.083,
    rx: 2.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.439,
    cy: 98.575,
    rx: 2.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.306,
    cy: 2.699,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.59,
    cy: 108.552,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.897,
    cy: 100.011,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.07,
    cy: 94.094,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.198,
    cy: 105.909,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.324,
    cy: 59.258,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.47,
    cy: 55.871,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.306,
    cy: 117.851,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.514,
    cy: 84.647,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.643,
    cy: 108.52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.762,
    cy: 105.709,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.967,
    cy: 99.957,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.071,
    cy: 68.709,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.765,
    cy: 105.547,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 182.924,
    cy: 101.428,
    r: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 177.079,
    cy: 111.212,
    rx: 2.5,
    ry: 2
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.05,
    points: "196.106 358.142 216.106 358.142 206.106 368.068",
    mask: "url(#face_leon_negative_svg__b)"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#face_leon_negative_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D4B680",
    d: "M137.271 112.218S196.804 188.68 238.027 212.3c21.352 12.234-16.128-39.293-.763-39.298 25.277-.008 86.044 51.605 81.279 37.76-35.657-60.3 32.009-30.066 9.602-45.403-68.717-92.117-190.874-53.141-190.874-53.141z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 10.8,
    d: "M144.067 115.947s68.45 97.883 106.311 103.099l-21.05-52.536 102.38 59.312-42.827-66.64 57.473 44.164s-31.78-87.12-60.37-90.057"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 9,
    d: "M176.575 350.055s15.97-11 31.019-11c15.047 0 33.107 11 33.107 11"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5.954,
    d: "M164.429 349.479c-.695.253-.644 2.148.115 4.234h0c.76 2.085 1.938 3.57 2.633 3.317M251.522 349.466c.74 0 1.339 1.799 1.339 4.018h0c0 2.219-.6 4.017-1.34 4.017"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceleonnegative);
export default __webpack_public_path__ + "static/media/face.leon.negative.b0d74bce.svg";
export { ForwardRef as ReactComponent };